export function getEnvVar(name: string): string {
  const environment = `${process.env.REACT_APP_ENVIRONMENT}`.toUpperCase()
  const value = process.env[`REACT_APP_${name}_${environment}`] || ''
  return value
}
